// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "td[data-v-3729401f],\nth[data-v-3729401f] {\n  vertical-align: middle;\n  white-space: nowrap;\n}", ""]);
// Exports
module.exports = exports;
